<style lang="less" scoped>

</style>
<template>
  <div class="stock-picker">
    <Tooltip placement="top" v-if="tip">
      <div @click="showItem">
        <slot></slot>
      </div>
      <div slot="content">点击查看</div>
    </Tooltip>
    <div @click="showItem" v-else>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    model_id:{
      type: Number,
    },
    tip: {
      type: Boolean,
      default: true
    },
    type:{
      type: String
    }
  },
  data(){
    return {
    }
  },
  computed: {
    //
  },
  created(){
    //
  },
  mounted(){
    //
  },
  methods: {
    showItem() {
      if (this.show_type === 'drawer') {
        this.showDrawer();
      } else {
        this.showViewer();
      }
    },
    showDrawer(){
      window.eventHub.$emit('drawer-show', this.model_id, this.type)
    },
    showViewer(){
      window.eventHub.$emit('viewer-show', this.model_id, this.type)
    }
  }
}
</script>
